'use strict';
$(document).ready(function () {
    $('.complete-your-look-card .cyl-link, .complete-your-look-card .icon-close').off('click').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var productSetID = $this.data('product-set-id')
        var $productWrapper = $('.complete-your-look-card.' + productSetID);

        if ($productWrapper.length) {
            $productWrapper.toggleClass('hide');
        }
    });

    $('.how-to-wear-btn').off('click').on('click', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $productWrapper = $btn.parents('.product-wrapper');
        var $target = $productWrapper.find('.complete-your-look-container');

        var headerHeight = $('#top-header').outerHeight();
        var stickyNavHeight = $('.addtocart-sticky-bar').outerHeight();
        if ($target.length) {
            var fixValue = headerHeight + stickyNavHeight;

            $('html, body').animate({
                scrollTop: $target.offset().top - fixValue
            }, 500);
        }
    });
});